<template>
    <div class="h-100">
        <bryntum-grid
            class               = "h-100"
            ref                 = "grid"
            v-bind  = "gridConfig"
        >
        </bryntum-grid>
    </div>
</template>

<script>
// Template für Actions
import { BryntumGrid } from '@bryntum/schedulerpro-vue';
import zipcelx from "zipcelx";

export default {
    name: "rms-objects-history-grid",
    props: ['rmsobjectid'],
    components:{
        BryntumGrid
    },

    data: function(){
        return {
            gridConfig:{
                /*
                    :minHeight          = "gridConfig.minHeight"
                    :columns            = "gridConfig.columns"
                    :store              = "gridConfig.store"
                    :headerMenuFeature  = "true"
                    :filter-bar-feature = "true"
                 */

                cellEditFeature: true,
                groupFeature: false,
                searchFeature: false,
                minHeight: '40em',
                columns : [
                    { text : this.$t('objects.changegrid.date'), field : 'created_at', flex : 2, editor : false, type: 'date', format: AshnetApp.dateTimeFormat,
                        renderer   : ({value}) => {
                            return moment.parseZone(value).format(AshnetApp.dateTimeFormat);
                        }
                    },
                    { text : this.$t('objects.changegrid.user'), field : 'user.name', flex : 1, editor : false},
                    { text : this.$t('objects.changegrid.action'), field : 'description', flex : 1, editor : false},
                    { text: this.$t('objects.changegrid.changes'), field: 'printable_log', flex: 8, editor: false,
                        autoHeight: true, htmlEncode: false, type: 'template',
                        template: ({record}) => {
                            let returnValue = '';
                            returnValue+='<div>';
                            for (const accessableLogEntry of record.data.accessable_log) {
                                returnValue+= "<span><pre>" + accessableLogEntry.name + ": <strike>" + accessableLogEntry.old + "</strike> → " + accessableLogEntry.new + "</pre></span>";

                            }
                            returnValue+='</div>';
                            return returnValue;
                        }
                    }
                ],
                store:{
                    syncDataOnLoad          : false,
                    useRestfulMethods       : true,
                    readUrl                 : '/api/rmsobjects/history/' + this.rmsobjectid,
                    autoLoad                : false,
                    headers: {
                        'X-CSRF-TOKEN'      : $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With'  : 'XMLHttpRequest',
                        'X-XSRF-TOKEN'      :  $('meta[name="xsrf-token"]').attr('content')
                    },
                },
                selectionMode: {
                    row: true,
                    cell: false,
                    rowCheckboxSelection: false,
                    multiSelect: false,
                    checkbox: false,
                    showCheckAll: false
                },
                listeners: {
                    cellDblClick: ({ record }) => {
                        if(AshnetApp.can('customers read')){
                            this.onViewAction(record.id)
                        }
                    }
                },
                tbar : {
                    items: [
                        {
                            type : 'button',
                            ref  : 'exportExcelButton',
                            icon : 'fad fa-file-excel',
                            text : this.$t('customers.grid.excel-export'),
                            listeners: {
                                click: this.onExportExcelClick
                            }
                        },
                        {
                            type : 'button',
                            ref  : 'exportButton',
                            icon : 'fad fa-file-export',
                            text : this.$t('customers.grid.pdf-png-export'),
                            listeners: {
                                click: this.onExportClick
                            }
                        }
                    ]
                },
                bbar : {
                    //type : 'pagingtoolbar'
                },

                pdfExportFeature: {
                    exportServer: 'https://exportdata.ashnet.cloud:8081',
                },
                excelExporterFeature : {
                    zipcelx
                },
                rowCopyPasteFeature : false,
                cellMenuFeature : {
                    items: {
                        removeRow: false,
                    }
                }
            },
            schemaModelFields: {
                id: { editable: false, nullable: true },
                first_name: { validation: { required: true } },
                last_name: { validation: { required: true }}
            },
        }
    },
    mounted() {
        // Initiales laden des Grids
        this.$refs.grid.gridInstance.store.load().then(() => {

        });
    },
    methods:{

        onExportExcelClick(){
            this.$refs.grid.gridInstance.features.excelExporter.export({
                filename : 'RM-Export-Customers',
                dateFormat : AshnetApp.dateTimeFormat,
            })
        },

        onExportClick(){
            this.$refs.grid.gridInstance.features.pdfExport.showExportDialog();
        }
    }
}
</script>

<style scoped>

</style>
